





















import { Component, Vue, Ref } from 'vue-property-decorator'
import { resetPassword } from '@/request/apis/UserRequest'
import { ElForm } from 'element-ui/types/form'

@Component
export default class ResetPasswordForm extends Vue {
  @Ref('form') readonly submitForm!: ElForm

  private form = {
    password: '',
    password2: ''
  }
  private loading: boolean = false

  private get rules () {
    const checkConfirmPassword = (rule: any, value: string, callback: Function) => {
      if (!(this.form.password === this.form.password2)) {
        return callback(new Error('Passwords do not match'))
      }
      callback()
    }
    return {
      password: [
        { required: true, message: this.$t('loginRegister.passwordEmptyError'), trigger: 'blur' }
      ],
      password2: [
        { required: true, message: this.$t('loginRegister.passwordEmptyError'), trigger: 'blur' },
        { validator: checkConfirmPassword, trigger: 'blur' }
      ]
    }
  }

  /**
   * 表单提交
   */
  private confirmHandler () {
    this.submitForm.validate(async (valid) => {
      if (valid) {
        this.loading = true
        try {
          let token = this.$route.query.token || ''
          await resetPassword(null, <string>token, this.form.password).start()
          this.$emit('resetSuccess', new CustomEvent('resetSuccess'))
        } catch (e) {
          console.log(e)
        }
        this.loading = false
      } else {
        return false
      }
    })
  }
}
